'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _core = require('libphonenumber-js/core');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _core.parsePhoneNumberFromString;
  }
});
//# sourceMappingURL=parsePhoneNumber.js.map